/** @format */
import { MnoMessageCollectionInterface } from '../../interfaces/collections/MnoMessageInterface';

export const provConstant = {
    MVNO_BLOCK_API_REQUEST_LIST: 'mvno_block_api_request_list',
    MVNO_BLOCK_REQUEST_STATE_LIST: 'mvno_block_request_state_list',
    MVNO_BLOCK_LIST_LIST: 'mvno_block_list_list',
    MVNO_BLOCK_VIEW_RELOAD: 'MVNO_BLOCK_VIEW_RELOAD',

    MVNO_BLOCK_REQUEST_ITEM: 'mvno_block_request_item',

    PLK_ORDERS_ITEM: 'plk_orders_item',
    PLK_ORDERS_LIST: 'plk_orders_list',

    MNO_MESSAGE_GET: 'MNO_MESSAGE_GET',
};

export type ProvReducerType = {
    type: string;
    items: any;
    itemsState: any;
    collections: any;
    mnoMessages?: MnoMessageCollectionInterface;
    reload?: boolean;
};

export function provReducer(state: any, action: ProvReducerType): object {
    switch (action.type) {
        case provConstant.MNO_MESSAGE_GET:
        case provConstant.MVNO_BLOCK_VIEW_RELOAD:
            return {
                ...state,
                ...action,
            };
        case provConstant.MVNO_BLOCK_API_REQUEST_LIST:
            return {
                type: action.type,
                items: action.collections,
            };
        case provConstant.MVNO_BLOCK_REQUEST_STATE_LIST:
            return {
                type: action.type,
                itemsState: action.collections,
            };
        default:
            return {
                ...state,
            };
    }
}
